import { ArrowLeft } from "lucide-react";
import { getIndustryCatalog } from "./industryCatalog";
import "./IndustryCardPicker.css";

export default function IndustryCardPicker({
  industry,
  activeId,
  onSelect,
  embed = false,
  showBack = false,
  onBack,
}) {
  const catalog = getIndustryCatalog(industry);
  if (!catalog) return null;

  return (
    <div className={`industry-picker${embed ? " industry-picker--embed" : ""}`}>
      {showBack && onBack && (
        <button type="button" className="industry-picker__back" onClick={onBack}>
          <ArrowLeft size={14} aria-hidden="true" />
          {catalog.label} 선택
        </button>
      )}
      <div className="industry-picker__header">
        <span className="industry-picker__eyebrow">{catalog.label} 홈페이지 데모</span>
        <h2 className="industry-picker__title">{catalog.pickerTitle}</h2>
        <p className="industry-picker__desc">{catalog.pickerDesc}</p>
      </div>
      <div className="industry-picker__grid" role="list">
        {catalog.items.map((item) => (
          <button
            key={item.id}
            type="button"
            role="listitem"
            className={`industry-picker__card${activeId === item.id ? " is-active" : ""}`}
            style={{ "--ip-accent": item.accent }}
            onClick={() => onSelect?.(item.id)}
            data-testid={`industry-card-${industry}-${item.id}`}
          >
            <div className="industry-picker__card-visual" style={{ background: item.preview }} />
            <div className="industry-picker__card-body">
              <span className="industry-picker__card-tag">{item.tag}</span>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
